const TWO_LETTERS = /[\p{Letter}\p{Mark}]{2,}/u;

export function nameValidation(value: string) {
  return TWO_LETTERS.test(value);
}
